<div class="topbar-item mr-5" *ngIf="!hideUserGuide && ('Pages.PaymentGateway.TransactionHistory' | permission)">   
    <a href="https://capstoragedata.blob.core.windows.net/landingpage/userguide/Commerce_Asia_Payments_Documentation.zip"
       class="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-3">   
        <i class="fas fa-book mr-2 text-dark-50"></i>
        <span class="text-dark-50 font-weight-bolder font-size-base">Download User Guide</span>
        
    </a>
</div>

<div dropdown class="dropdown dropdown-language" aria-haspopup="true" *ngIf="languages.length > 1" [dropup]="isDropup">
    <div dropdownToggle class="topbar-item" data-toggle="dropdown" data-offset="10px,0px" aria-expanded="false">
        <div [class]="customStyle">
            <i [class]="currentLanguage.icon"></i>
        </div>
    </div>
    <div *dropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right" [attr.aria-label]="l('Languages')">
        <perfect-scrollbar style="height: 80vh">
            <ul class="navi navi-hover py-4">
                <li class="navi-item" *ngFor="let language of languages">
                    <a href="javascript:;" (click)="changeLanguage(language.name)" class="navi-link">
                        <span class="symbol symbol-20 mr-3">
                            <i [class]="language.icon"></i>
                        </span>
                        <span class="navi-text">
                            {{language.displayName}}
                        </span>
                    </a>
                </li>
            </ul>
        </perfect-scrollbar>
    </div>
</div>